import Select, { type MultiValue, type SingleValue } from "react-select";
import { Loading, QueryError } from "@/components/Loading/Loading";
import type { TiposSeleccionFiltroStock } from "@/hooks/Api/Articulos";
import { useFamilias, useSubFamilias } from "@/hooks/Api/Familias";

interface FiltroArticulosProps {
	readonly filtroStock: TiposSeleccionFiltroStock;
	readonly setFiltroStock: (value: TiposSeleccionFiltroStock) => void;
	readonly familia: string[];
	readonly setFamilia: (value: string[]) => void;
	readonly subfamilia: string[];
	readonly setSubfamilia: (value: string[]) => void;
	readonly tipoArticulo: string[];
	readonly setTipoArticulo: (value: string[]) => void;
}
export function FiltroArticulos(props: FiltroArticulosProps) {

	const { data: familias, error: errorFamilias, isPending: isPendingFamilias } = useFamilias();
	const { data: subfamilias, error: errorSubfamilias, isPending: isPendingSubfamilias } = useSubFamilias();
	const optionsStock = [
		{ value: "todo", label: "Todos" },
		{ value: "enStock", label: "En Stock" },
		{ value: "minimo", label: "Bajo mínimo" },
		{ value: "minimo-request", label: "Bajo mínimo (Requiere pedir)" },
		{ value: "maximo", label: "Sobre máximo" },
		{ value: "roturaStock", label: "Rotura de stock" },
		{ value: "roturaStock-request", label: "Rotura de stock (Requiere pedir)" },
	];
	const optionsTipo = [
		{ value: "1", label: "Compras" },
		{ value: "2", label: "OF" },
		{ value: "5", label: "OPE" },
	];

	if (errorFamilias) return <QueryError error={errorFamilias} fallback="Error al cargar las familias" />;
	if (errorSubfamilias) return <QueryError error={errorSubfamilias} fallback="Error al cargar las subfamilias" />;


	if (isPendingFamilias || isPendingSubfamilias) return <Loading />;

	const onChangeFam = (newValue: MultiValue<{ value: string; label: string; }>) => {
		const selectedIds = newValue.map((option) => option.value);
		props.setFamilia(selectedIds);
	};
	const onChangeSubfam = (newValue: MultiValue<{ value: string; label: string; }>) => {
		const selectedIds = newValue.map((option) => option.value);
		props.setSubfamilia(selectedIds);
	};
	const onChangeStock = (newValue: SingleValue<{ value: string; label: string; }>) => {
		props.setFiltroStock((newValue?.value ?? "todo") as TiposSeleccionFiltroStock);
	};
	const onChangeTipo = (newValue: MultiValue<{ value: string; label: string; }>) => {
		const selectedIds = newValue.map((option) => option.value);
		props.setTipoArticulo(selectedIds);
	};

	const familiaValue = familias.filter(fam => props.familia.includes(fam.idFamilia)).map(fam => ({ value: fam.idFamilia, label: fam.nombreFamilia }));
	const subfamiliasValue = subfamilias.filter(subfam => props.subfamilia.includes(subfam.idSubFamilia)).map(subfam => ({ value: subfam.idSubFamilia, label: subfam.nombreSubFamilia }));
	const stockValue = optionsStock.find(opt => opt.value === props.filtroStock);
	const tipoValue = optionsTipo.filter(opt => props.tipoArticulo.includes(opt.value));

	return (
		<div className="inputContainerGrid" role="tabpanel" style={{ padding: 30 }} >
			<label>Familias: </label>
			<Select
				options={familias.map((fam) => ({ value: fam.idFamilia, label: fam.nombreFamilia }))}
				isMulti
				className=""
				value={familiaValue}
				onChange={onChangeFam}
			/>

			<label>Subfamilias: </label>
			<Select
				options={subfamilias.map((subfam) => ({ value: subfam.idSubFamilia, label: subfam.nombreSubFamilia }))}
				isMulti
				className=""
				value={subfamiliasValue}
				onChange={onChangeSubfam}
			/>
			<label>Stock: </label>
			<Select
				options={optionsStock}
				className=""
				value={stockValue}
				onChange={onChangeStock}
			/>
			<label>Tipo: </label>
			<Select
				options={optionsTipo}
				isMulti
				className=""
				value={tipoValue}
				onChange={onChangeTipo}
			/>
		</div>
	);
}